import React from "react";

import { InputNumber, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

function NumberRange({ value = {}, onChange }) {
  const { t } = useTranslation();

  const handleMinChange = (minVal) => {
    onChange({ ...value, min: minVal });
  };

  const handleMaxChange = (maxVal) => {
    onChange({ ...value, max: maxVal });
  };

  return (
    <Space.Compact style={{ width: '100%', display: 'flex' }}>
      <InputNumber
        value={value?.min}
        onChange={handleMinChange}
        placeholder={t('comparison.bigger_than')}
        style={{ flex: 1 }}
        controls={false}
      />
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        backgroundColor: '#fafafa',
        border: '1px solid #d9d9d9',
        borderLeft: 'none',
        borderRight: 'none'
      }}>
        <Text type="secondary">~</Text>
      </div>
      <InputNumber
        value={value?.max}
        onChange={handleMaxChange}
        placeholder={t('comparison.smaller_than')}
        style={{ flex: 1 }}
        controls={false}
      />
    </Space.Compact>
  );
}

export default NumberRange;
